import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(value) {
  let valueFormatter = "";
  let format = "dd/mm/yyyy";

  let dateObj = value ? new Date(value) : new Date();
  let momentObj = moment(dateObj);

  switch (format) {
    case "dd/mm/yyyy":
      valueFormatter = momentObj.format("DD/MM/YYYY");
      break;
    case "mm/dd/yyyy":
      valueFormatter = momentObj.format("MM/DD/YYYY");
      break;
  }
  return valueFormatter;
});

Vue.filter("formatTime", function(value) {
  let valueFormatter = "";
  let format = "H:i";

  let dateObj = value ? new Date(value) : new Date();
  let momentObj = moment(dateObj);

  switch (format) {
    case "H:i":
      valueFormatter = momentObj.format("HH:mm");
      break;
    case "h:i":
      valueFormatter = momentObj.format("hh:mm");
      break;
  }
  return valueFormatter;
});
